/**
 * Shared utility to load the Chartara Labs logo for PDF generation.
 * Loads from the public folder at runtime and converts to base64 data URL.
 * Cached after first load so subsequent PDF generations are instant.
 */

let cachedLogoDataUrl = null;

export const loadLogoForPDF = async () => {
  if (cachedLogoDataUrl) return cachedLogoDataUrl;

  try {
    const response = await fetch('/chartara_labs_logo.png');
    if (!response.ok) throw new Error('Logo fetch failed');

    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        cachedLogoDataUrl = reader.result;
        resolve(cachedLogoDataUrl);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    console.warn('Could not load logo for PDF:', e);
    return null;
  }
};

/**
 * Helper to add the logo to a jsPDF page.
 * Handles aspect ratio automatically based on the original image dimensions.
 */
export const addLogoToPDF = (pdf, logoDataUrl, x, y, maxWidth, maxHeight) => {
  if (!logoDataUrl) return;
  try {
    pdf.addImage(logoDataUrl, 'PNG', x, y, maxWidth, maxHeight);
  } catch (e) {
    console.warn('Logo render failed:', e);
  }
};
